/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 */

import React from 'react';
//@ts-ignore
import {GetLocalizedText,GetLocalizedPrice,ReturnProductDetailLink,GenerateProductAssetUrl} from './../../themes/kent/utilities/functions';
//@ts-ignore
import {GeneralAssetUrl} from './../../themes/kent/utilities/constants';

interface IProps {
  image?:string;
  products?:any;
  athletes?:any;
  year?:any;
}

interface IState {
  onFullScreenImageLoaded:boolean;
}

/**
 *
 * Tagged Image Overlay component
 * @extends {React.Component}
 */

class HosportsTaggedImageOverlay extends React.Component<IProps> {

  public state: IState;

  constructor(props: IProps) {
    super(props);
    this.state = {
      onFullScreenImageLoaded:false,
    };
  }

  public onFullScreenImageLoad = () => {
    this.setState({
      onFullScreenImageLoaded:true
    })
  }

  public render(): JSX.Element {
    let fullScreenImageLoadedClass:string = "";
    let prodAssetUrl:any = GenerateProductAssetUrl(this.props.year);
    if(this.state.onFullScreenImageLoaded){
      fullScreenImageLoadedClass = "loaded"
    }
    return (
      <div className="tagged-image-full-screen-container row active full-height full-width">
        <img className={"tagged-image-background-preload"} src={this.props.image} onLoad={this.onFullScreenImageLoad} />
        <h4 className="show-for-small tagged-image-overlay-container-title-sm white small-padding">{'In This Photo'}</h4>
        <div className="tagged-image-overlay-image-wrapper">
          <div
            className={"tagged-image-overlay-image "+fullScreenImageLoadedClass}
            style={{backgroundImage:'url('+this.props.image+')'}}>
          </div>
        </div>
        <div
          className="tagged-image-overlay-tag-container dark-grey-background">
          <h4 className="hide-for-small tagged-image-overlay-container-title white">{'In This Photo'}</h4>
          {this.props.athletes && this.props.athletes.map((data:any) =>{
            let link:string = "/rider/"+data.attributes.slug;
            let image:string ="";
            if(data.attributes && data.attributes.cover){
              image = data.attributes.cover.url();
            }
            let name:string = data.attributes.firstName+" "+data.attributes.lastName;
            return(
              <div className="border-bottom tagged-image-overlay-product">
                <a href={link} className="row">
                  <div className="small-4 medium-4 tagged-image-overlay-product-image centered-text">
                    <img className="full-width circle background-image-fill" src={GeneralAssetUrl+'square.png'} style={{backgroundImage:'url(https://assets.hosports.com/image.php?src='+image+'&h=200&w=200&zc=1)'}} />
                  </div>
                  <div className="small-8 medium-8 tagged-image-overlay-product-text" style={{display:'flex', alignItems:'center'}}>
                      <div className="full-width">
                        <h6 className="white">{name}</h6>
                        <p className="white subheading">&nbsp;</p>
                      </div>
                  </div>
                </a>
              </div>
            )
          })}
          {this.props.products && this.props.products.map((data:any) =>{
            let link:string = "/product/"+data.attributes.slug;
            let title:any = GetLocalizedText(data.attributes.content,'title');
            return(
              <div className="border-bottom tagged-image-overlay-product">
                <a href={link} className="row">
                  <div className="small-4 medium-4 tagged-image-overlay-product-image">
                    <img className="full-width background-image-fill black-background circle" src={GeneralAssetUrl+'square.png'} style={{backgroundImage:'url('+prodAssetUrl+data.attributes.slug+'1_500.png'+')'}} />
                  </div>
                  <div className="small-8 medium-8 tagged-image-overlay-product-text" style={{display:'flex', alignItems:'center'}}>
                      <div className="full-width">
                        <h6 className="white">{title}</h6>
                      </div>
                  </div>
                </a>
              </div>
            )
          })}
        </div>
    </div>
    );
  }
}

export default HosportsTaggedImageOverlay;
